const colorHue = 150;
const greyHue = 191;

const pallete = {
  color: `hsla(${colorHue}, 82%, 50%, 1)`,
  hover: `hsla(${colorHue}, 62%, 72%, 1)`,
  light: `hsla(${colorHue}, 70%, 83%, 1)`,
  background: `hsla(${greyHue}, 12%, 27%, 1)`,
  backgroundOverlay: `hsla(${greyHue}, 12%, 27%, 0.6)`,
  scrollbar: `hsla(${greyHue}, 12%, 27%, 0.55)`,
  error: '#ED1E3E',
  lightTextColor: '#CED7D9', // #CED7D9
  lightBackground: '#f5f5f5',
  white: '#ffffff',
  hr: '#e8e8e8',
};

const theme = {
  pallete,

  font: {
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: pallete.lightTextColor,
  },
  link: {
    color: pallete.color,
  },

  transitions: {
    default: 'all 500ms cubic-bezier(0.230, 1.000, 0.320, 1.000)',
    fast: 'all 250ms cubic-bezier(0.230, 1.000, 0.320, 1.000)',
    slow: 'all 750ms cubic-bezier(0.230, 1.000, 0.320, 1.000)',
  },
};

export default theme;



// WEBPACK FOOTER //
// ./src/themes/green.js